<template>
  <v-dialog v-model="show" persistent max-width="450px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon text x-small class="ml-2" v-bind="attrs" v-on="on">
        <v-icon class="small">fad fa-edit</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title><span class="headline">Edit Business</span></v-card-title>
      <v-card-text>
        <v-container>
          <v-row no-gutters>
            <v-col>
              <v-layout wrap>
                <v-flex xs12>
                  <v-switch label="Limited Company" v-model="isLimited" hide-details></v-switch>
                </v-flex>
                <v-flex xs12 v-if="isLimited">
                  <v-autocomplete
                    v-model="companiesHouse"
                    :items="businesses"
                    :search-input.sync="companiesHouseSearch"
                    hide-no-data
                    item-text="title"
                    item-value="API"
                    label="Company name"
                    return-object
                    prepend-icon="fad fa-search"
                    :no-filter="true"
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title v-text="item.title"></v-list-item-title>
                        <v-list-item-subtitle v-text="item.address_snippet"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12 v-if="!isLimited">
                  <v-autocomplete
                    v-model="loqateQuery"
                    :items="loqate"
                    :search-input.sync="loqateQuerySearch"
                    hide-no-data
                    item-text="Text"
                    item-value="API"
                    label="Company name or address"
                    return-object
                    prepend-icon="fad fa-search"
                    :no-filter="true"
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title v-text="item.Text"></v-list-item-title>
                        <v-list-item-subtitle v-text="item.Description"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12 v-if="!isLimited && showAddressSelect">
                  <v-select v-model="selectedAddress" :items="loqateOptions" placeholder="Select an address"></v-select>
                </v-flex>
                <v-flex xs12 v-if="business.BusinessLocation.LocationLine1 !== null">
                  <v-text-field label="Company Name" v-model="business.CommercialName" required></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 v-if="business.BusinessLocation.LocationLine1 !== null">
                  <v-text-field
                    label="Address Line 1"
                    v-model="business.BusinessLocation.LocationLine1"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 v-if="business.BusinessLocation.LocationLine1 !== null">
                  <v-text-field label="Address Line 2" v-model="business.BusinessLocation.LocationLine2"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 v-if="business.BusinessLocation.LocationLine1 !== null">
                  <v-text-field label="Address Line 3" v-model="business.BusinessLocation.LocationLine3"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 v-if="business.BusinessLocation.LocationLine1 !== null">
                  <v-text-field label="Address Line 4" v-model="business.BusinessLocation.LocationLine4"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 v-if="business.BusinessLocation.LocationLine1 !== null">
                  <v-text-field label="Address Line 5" v-model="business.BusinessLocation.LocationLine5"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 v-if="business.BusinessLocation.LocationLine1 !== null">
                  <v-text-field label="Postcode" v-model="business.BusinessLocation.Postcode" required></v-text-field>
                </v-flex>
              </v-layout>
            </v-col>
          </v-row>
        </v-container>
        <v-alert color="red" dense type="error" v-if="RegistrationBusinessExists">
          Business is already registered
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" text @click="show = false">
          Cancel
        </v-btn>
        <v-btn color="accent darken-1" :disabled="RegistrationBusinessExists" @click="prepareDetailsAndUpdate">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import companiesHouse from '@/api/companiesHouse';
import loqate from '@/api/loqate';
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'EditBusiness',
  props: {
    customer: Object
  },
  data: () => ({
    show: false,
    business: {
      BusinessRef: null,
      RegisteredCompanySicCodes: null,
      CommercialName: null,
      BusinessLocation: {
        LocationLine1: null,
        LocationLine2: null,
        LocationLine3: null,
        LocationLine4: null,
        LocationLine5: null,
        Postcode: null
      }
    },
    isLimited: true,
    companiesHouse: null,
    companiesHouseSearch: null,
    loqateQuery: null,
    lastLoqateQuery: null,
    loqateQuerySearch: null,
    loqateQueryName: null,
    loqateQueryNameSearch: null,
    showAddressSelect: false,
    businesses: [],
    loqate: [],
    selectedAddress: null,
    searching: false
  }),
  computed: {
    ...mapGetters(['RegistrationBusinessExists']),
    loqateOptions: function() {
      return [
        { value: null, text: 'Select an address', disabled: true },
        ...this.loqate.map(address => {
          return { value: address.Id, text: `${address.Text}, ${address.Description}` };
        })
      ];
    }
  },
  methods: {
    ...mapActions(['selectCustomer', 'updateRegistration', 'verifyRegistrationBusiness']),
    searchCompaniesHouse: function(q) {
      companiesHouse.searchCompanies(q, 10, 0).then(result => (this.businesses = result.items));
    },
    searchLoqate: function(q) {
      if (!this.searching) {
        this.showAddressSelect = false;
        loqate.search(q).then(result => {
          if (result.Items.length === 1 && result.Items[0].Type === 'Postcode') {
            this.selectLoqateBusiness(result.Items[0]);
          } else {
            this.loqate = result.Items;
          }
        });
      }
    },
    selectBusiness: async function(business) {
      business.sic_codes = await companiesHouse.getSicCodes(business.company_number).catch(() => null);
      business.sic_codes = business.sic_codes ? JSON.stringify(business.sic_codes) : null;

      this.business = {
        BusinessRef: business.company_number,
        RegisteredCompanySicCodes: business.sic_codes,
        CommercialName: business.title,
        BusinessLocation: {
          LocationLine1: `${business.address.premises}, ${business.address.address_line_1}`,
          LocationLine2: business.address.address_line_2,
          LocationLine3: business.address.Locality,
          LocationLine4: business.address.region,
          LocationLine5: null,
          Postcode: business.address.postal_code
        }
      };
      this.verifyRegistrationBusiness(this.business.BusinessRef);
      this.manualAddress = true;
    },
    selectLoqateBusiness: function(business) {
      this.showAddressSelect = false;
      this.searching = true;
      if (typeof business === 'string') {
        business = { Id: business, Type: null };
      }
      if (business.Type === 'Postcode') {
        loqate.searchContainer(business.Text, business.Id).then(result => {
          this.loqate = result.Items;
          this.showAddressSelect = true;
        });
      } else {
        loqate.retrieve(business.Id).then(
          response =>
            (this.business = {
              BusinessRef: response.Items[0].Id,
              CommercialName: response.Items[0].Company,
              BusinessLocation: {
                LocationLine1: response.Items[0].Line1,
                LocationLine2: response.Items[0].District,
                LocationLine3: response.Items[0].City,
                LocationLine4: response.Items[0].Province,
                LocationLine5: null,
                Postcode: response.Items[0].PostalCode
              }
            })
        );
      }
      this.searching = false;
    },
    isDefined(value) {
      return _.isUndefined(value) === false;
    },
    prepareDetailsAndUpdate() {
      this.show = false;
      let updateData = this.customer;
      updateData.name = this.business.CommercialName;
      updateData.address.line_1 = this.business.BusinessLocation.LocationLine1;
      updateData.address.line_2 = this.business.BusinessLocation.LocationLine2;
      updateData.address.line_3 = this.business.BusinessLocation.LocationLine3;
      updateData.address.line_4 = this.business.BusinessLocation.LocationLine4;
      updateData.address.line_5 = this.business.BusinessLocation.LocationLine5;
      updateData.address.post_code = this.business.BusinessLocation.Postcode;
      updateData.business_ref = this.business.BusinessRef;
      updateData.registered_company_sic_codes = this.business.RegisteredCompanySicCodes;
      updateData.is_limited = this.isLimited;

      this.updateRegistration({ updateData }).then(() => this.selectCustomer(this.customer.id));
    }
  },
  watch: {
    companiesHouseSearch: _.debounce(function(newQuery) {
      this.searchCompaniesHouse(newQuery);
    }, 250),
    companiesHouse: function(business) {
      this.selectBusiness(business);
    },
    loqateQuery: function(business) {
      this.selectLoqateBusiness(business);
    },
    loqateQuerySearch: _.debounce(function(newQuery = '', oldQuery = '') {
      if (newQuery.length < 3) {
        this.loqate = [];
      } else if (newQuery.toLowerCase() !== oldQuery.toLowerCase() && newQuery !== this.lastLoqateQuery) {
        this.searchLoqate(newQuery);
        this.lastLoqateQuery = newQuery;
      }
    }, 250),
    loqateQueryNameSearch: _.debounce(function(newQuery = '', oldQuery = '') {
      if (newQuery.length < 3) {
        this.loqate = [];
      } else if (newQuery.toLowerCase() !== oldQuery.toLowerCase()) {
        this.searchLoqate(newQuery);
      }
    }, 250),
    selectedAddress: function(id) {
      this.selectLoqateBusiness(id);
    }
  }
};
</script>

<style scoped></style>
